import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { DashboardHome, NewsList } from './AdminDashboard';
import Article from './Article';
import EditArticle from './EditArticle';

function AdminRoutes({ 
  onViewArticle,
  onBackToNews,
  editingArticleId, 
  editingArticleData,
  userRole
}) {
  // Admin can edit articles but only see approve/reject buttons (no publish)
  // Approver can edit and see all buttons including publish
  const isReadOnlyForQM = false;

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin/dashboard" />} />
      <Route path="/dashboard" element={<DashboardHome userRole={userRole} />} />
      <Route path="/news" element={
        editingArticleId ? (
          <EditArticle 
            articleId={editingArticleId} 
            articleData={editingArticleData}
            onBack={onBackToNews}
            isReadOnly={isReadOnlyForQM}
            userRole={userRole}
          />
        ) : (
          <NewsList onViewArticle={onViewArticle} userRole={userRole} />
        )
      } />
      <Route path="/addnewsarticle" element={<Article />} />
      <Route path="/editarticle/:id" element={
        editingArticleId ? (
          <EditArticle 
            articleId={editingArticleId} 
            articleData={editingArticleData}
            onBack={onBackToNews}
            isReadOnly={isReadOnlyForQM}
            userRole={userRole}
          />
        ) : (
          <Navigate to="/admin/news" />
        )
      } />
      <Route path="*" element={<Navigate to="/admin/dashboard" />} />
    </Routes>
  );
}

export default AdminRoutes;
